import Cookies from 'js-cookie';
import actions from './actions';

const {
  OTP_BEGIN,
  OTP_SUCCESS,
  OTP_ERR,
  LOGIN_BEGIN,
  LOGIN_SUCCESS,
  LOGIN_ERR,
  LOGOUT_BEGIN,
  LOGOUT_SUCCESS,
  LOGOUT_ERR,
} = actions;

const initState = {
  login: Cookies.get('logedIn'),
  loading: false,
  profile: {},
  error: null,
};

/**
 *
 * @todo impure state mutation/explaination
 */
const AuthReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LOGIN_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        login: data.isLoggedIn,
        profile: data.profile,
        loading: false,
        error: null,
      };
    case LOGIN_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case OTP_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case OTP_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case LOGOUT_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        login: data,
        loading: false,
      };
    case LOGOUT_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default AuthReducer;
